import { render, staticRenderFns } from "./QuizBox.vue?vue&type=template&id=4da8e79f"
import script from "./QuizBox.vue?vue&type=script&lang=js"
export * from "./QuizBox.vue?vue&type=script&lang=js"
import style0 from "./QuizBox.vue?vue&type=style&index=0&id=4da8e79f&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports